"use client"

import { Col, Row } from "antd"

const PageLoading = () => {
  return (
    <Row justify='center' align='middle' className="root__loading-page">
      <Col>
        <div className="loader" />
      </Col>
    </Row>
  )
}

export default PageLoading